import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HubIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hub"}/>
}
